module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"search_placeholder":"리뷰 키워드 검색"}}')
  delete Component.options._Ctor
}
